const apiStatusMutations = {
  api_request (state) {
    state.apiStatus = 'loading'
  },
  api_error (state) {
    state.apiStatus = 'error'
  },
  api_success (state) {
    state.apiStatus = 'success'
  }
}

export default apiStatusMutations



// WEBPACK FOOTER //
// ./src/utils/store/apiStatusMutations.js